/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const MailTriageRecordClassifierEnum = {
    deterministic: 'deterministic',
    llm: 'llm'
};
/**
 * @export
 */
export const MailTriageRecordSourceEnum = {
    human: 'human',
    machine: 'machine'
};
/**
 * @export
 */
export const MailTriageRecordUrgencyEnum = {
    ignore: 'ignore',
    normal: 'normal',
    urgent: 'urgent'
};
/**
 * Check if a given object implements the MailTriageRecord interface.
 */
export function instanceOfMailTriageRecord(value) {
    if (!('category' in value) || value['category'] === undefined)
        return false;
    if (!('classifier' in value) || value['classifier'] === undefined)
        return false;
    if (!('link' in value) || value['link'] === undefined)
        return false;
    if (!('messageId' in value) || value['messageId'] === undefined)
        return false;
    if (!('receivedAt' in value) || value['receivedAt'] === undefined)
        return false;
    if (!('sender' in value) || value['sender'] === undefined)
        return false;
    if (!('source' in value) || value['source'] === undefined)
        return false;
    if (!('subject' in value) || value['subject'] === undefined)
        return false;
    if (!('suggestedAction' in value) || value['suggestedAction'] === undefined)
        return false;
    if (!('threadId' in value) || value['threadId'] === undefined)
        return false;
    if (!('triagedAt' in value) || value['triagedAt'] === undefined)
        return false;
    if (!('urgency' in value) || value['urgency'] === undefined)
        return false;
    return true;
}
export function MailTriageRecordFromJSON(json) {
    return MailTriageRecordFromJSONTyped(json, false);
}
export function MailTriageRecordFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'category': json['category'],
        'classifier': json['classifier'],
        'draftId': json['draft_id'] == null ? undefined : json['draft_id'],
        'labelApplied': json['label_applied'] == null ? undefined : json['label_applied'],
        'link': json['link'],
        'messageId': json['message_id'],
        'metrics': json['metrics'] == null ? undefined : json['metrics'],
        'ntfySent': json['ntfy_sent'] == null ? undefined : json['ntfy_sent'],
        'receivedAt': (new Date(json['received_at'])),
        'sender': json['sender'],
        'source': json['source'],
        'subject': json['subject'],
        'suggestedAction': json['suggested_action'],
        'threadId': json['thread_id'],
        'triagedAt': (new Date(json['triaged_at'])),
        'urgency': json['urgency'],
    };
}
export function MailTriageRecordToJSON(json) {
    return MailTriageRecordToJSONTyped(json, false);
}
export function MailTriageRecordToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'category': value['category'],
        'classifier': value['classifier'],
        'draft_id': value['draftId'],
        'label_applied': value['labelApplied'],
        'link': value['link'],
        'message_id': value['messageId'],
        'metrics': value['metrics'],
        'ntfy_sent': value['ntfySent'],
        'received_at': value['receivedAt'].toISOString(),
        'sender': value['sender'],
        'source': value['source'],
        'subject': value['subject'],
        'suggested_action': value['suggestedAction'],
        'thread_id': value['threadId'],
        'triaged_at': value['triagedAt'].toISOString(),
        'urgency': value['urgency'],
    };
}
